/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FieldType {
	None = 'None',
	Text = 'Text',
	Number = 'Number',
	Email = 'Email',
	Currency = 'Currency',
	Website = 'Website',
	Date = 'Date',
	Phone = 'Phone',
	Choice = 'Choice',
	YesNo = 'YesNo',
	Person = 'Person',
	Name = 'Name',
	Address = 'Address',
	Entity = 'Entity',
	EntityList = 'EntityList',
	File = 'File',
	Calculation = 'Calculation',
	Duration = 'Duration',
	RatingScale = 'RatingScale',
	Signature = 'Signature',
	Lookup = 'Lookup',
	Document = 'Document',
}
